// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"222":"edba6d33","241":"becebaad","527":"9aca141a","761":"34d7d569","842":"38753fcf","873":"eb6aad06"}[chunkId] + ".css";
};